export const getItemFromSessionStorage = (key: string) =>
  sessionStorage.getItem(key);

export const setItemToSessionStorage = (key: string, data: string) => {
  sessionStorage.setItem(key, data);
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const removeItemFromSessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
